import { Outlet, Link } from "react-router-dom";

export default function PublicLayout() {
  return (
    <div className="min-h-screen">
      
      <Outlet />
    </div>
  );
}
